/* BT Quick Order - заявка за обаждане от продуктовата страница (balkantuning.com) */
(() => {
  if (customElements.get('bt-quick-order')) return;

  const TZ = 'Europe/Sofia';
  const CUSTOMER_KEY = 'btqo:customer';
  const VEHICLE_KEY = 'vehicleFinder:selection';
  const DAY_NAMES = ['неделя', 'понеделник', 'вторник', 'сряда', 'четвъртък', 'петък', 'събота'];

  const store = {
    get(area, key) {
      try { return JSON.parse(window[area].getItem(key)); } catch (_) { return null; }
    },
    set(area, key, value) {
      try { window[area].setItem(key, JSON.stringify(value)); } catch (_) {}
    },
    remove(area, key) {
      try { window[area].removeItem(key); } catch (_) {}
    }
  };

  // "0888 123 456" → "+359888123456"; връща null ако не прилича на телефон.
  function normalizePhone(raw) {
    const value = String(raw || '').trim();
    if (!/^\+?[\d\s().\/-]+$/.test(value)) return null;
    let digits = value.replace(/\D/g, '');
    if (value.startsWith('+')) digits = '+' + digits;
    else if (digits.startsWith('00')) digits = '+' + digits.slice(2);
    else if (digits.startsWith('359')) digits = '+' + digits;
    else if (digits.startsWith('0') && digits.length === 10) digits = '+359' + digits.slice(1);
    const count = digits.replace('+', '').length;
    if (count < 8 || count > 15) return null;
    if (digits.startsWith('+359') && count !== 12 && count !== 11) return null;
    return digits;
  }

  function parseRange(text) {
    const m = String(text || '').match(/^\s*(\d{1,2})(?::(\d{2}))?\s*-\s*(\d{1,2})(?::(\d{2}))?\s*$/);
    if (!m) return null;
    return { from: +m[1] * 60 + (+m[2] || 0), to: +m[3] * 60 + (+m[4] || 0), label: m[1] + (m[2] ? ':' + m[2] : ':00') };
  }

  function sofiaNow() {
    const parts = Object.fromEntries(
      new Intl.DateTimeFormat('en-GB', { timeZone: TZ, weekday: 'short', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' })
        .formatToParts(new Date())
        .map(p => [p.type, p.value])
    );
    const day = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].indexOf(parts.weekday);
    return { day, minutes: +parts.hour * 60 + +parts.minute };
  }

  function track(name, detail) {
    try {
      (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: name }, detail));
      window.Shopify?.analytics?.publish?.(name, detail);
      if (name === 'btqo_success') {
        window.gtag?.('event', 'generate_lead', { currency: window.Shopify?.currency?.active || 'EUR', value: detail.value || 0 });
        window.fbq?.('track', 'Lead', { content_name: detail.product });
      }
    } catch (_) {}
  }

  customElements.define('bt-quick-order', class extends HTMLElement {
    connectedCallback() {
      this.initTimer = setTimeout(() => this.init(), 0);
    }

    disconnectedCallback() {
      clearTimeout(this.initTimer);
      clearTimeout(this.slowTimer);
      window.removeEventListener('pageshow', this.onPageShow);
      document.removeEventListener('vf:change', this.onVehicleChange);
      this.dialog?.remove();
      this.dialog = null;
    }

    init() {
      if (!this.isConnected || this.dialog) return;
      const template = this.querySelector('template');
      if (!template) return;

      this.variants = JSON.parse(this.querySelector('[data-btqo-variants]').textContent);
      this.scope = this.closest('.shopify-section') || document;
      this.opener = this.querySelector('.btqo-open');
      this.dialog = template.content.querySelector('dialog').cloneNode(true);
      document.body.append(this.dialog);

      this.form = this.dialog.querySelector('form');
      this.submitButton = this.dialog.querySelector('.btqo-submit');
      this.errorBox = this.dialog.querySelector('[data-btqo-error]');
      this.pendingKey = 'btqo:pending:' + this.id;
      this.hours = { week: parseRange(this.dataset.hours), sat: parseRange(this.dataset.hoursSat) };

      this.opener.disabled = false;
      this.opener.addEventListener('click', () => this.openForm());
      this.dialog.querySelectorAll('[data-btqo-close]').forEach(b => b.addEventListener('click', () => this.dialog.close()));
      this.dialog.querySelectorAll('[data-btqo-track]').forEach(a =>
        a.addEventListener('click', () => track('btqo_direct_contact', { channel: a.dataset.btqoTrack, product: this.dataset.title }))
      );

      // Клик върху фона затваря прозореца.
      this.dialog.addEventListener('click', e => {
        if (e.target !== this.dialog) return;
        const r = this.dialog.getBoundingClientRect();
        if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) this.dialog.close();
      });
      this.dialog.addEventListener('close', () => {
        if (!this.dialog.querySelector('.btqo-success').hidden) this.resetForm();
        this.opener?.focus({ preventScroll: true });
      });

      this.form.addEventListener('input', e => {
        e.target.setCustomValidity?.('');
        e.target.removeAttribute('aria-invalid');
        this.errorBox.hidden = true;
      });
      this.form.elements['contact[phone]'].addEventListener('blur', e => {
        const normalized = normalizePhone(e.target.value);
        if (normalized) e.target.value = normalized;
      });
      this.dialog.querySelector('[data-btqo-vin]').addEventListener('input', e => {
        e.target.value = e.target.value.toUpperCase().replace(/[^A-Z0-9]/g, '');
      });
      this.form.addEventListener('submit', e => this.onSubmit(e));

      this.onPageShow = () => this.setBusy(false);
      window.addEventListener('pageshow', this.onPageShow);
      this.onVehicleChange = () => this.renderCallout();
      document.addEventListener('vf:change', this.onVehicleChange);

      this.renderCallout();
      this.renderAvailability();
      this.restoreAfterNativeSubmit();
    }

    /* ---------- Автомобил и съвместимост (интеграция с vehicle finder на темата) ---------- */

    vehicle() {
      const sel = store.get('localStorage', VEHICLE_KEY);
      if (!sel || !sel.make) return null;
      const name = [sel.make, sel.model, sel.gen].filter(Boolean).join(' ');
      const badge = this.scope.querySelector('[data-vf-fit-badge]');
      let fit = 'неизвестна';
      if (badge?.classList.contains('vf-fit__badge--ok')) fit = 'Да - посочен като подходящ';
      else if (badge?.classList.contains('vf-fit__badge--no')) fit = 'НЕ е посочен като подходящ - провери';
      return { name, fit, ok: fit.startsWith('Да'), no: fit.startsWith('НЕ') };
    }

    renderCallout() {
      const el = this.querySelector('[data-btqo-callout]');
      const v = this.vehicle();
      if (!v) return;
      const b = document.createElement('b');
      b.textContent = v.name;
      if (v.ok) el.replaceChildren('Подходящ за твоя ', b, '. Искаш да поръчаш по телефона или имаш въпрос?');
      else if (v.no) el.replaceChildren('Не е посочен за твоя ', b, ' - провери безплатно с наш специалист преди да поръчаш.');
      else el.replaceChildren('Не си сигурен дали продуктът става за твоя ', b, '? Ще проверим вместо теб.');
    }

    /* ---------- Работно време ---------- */

    schedule() {
      const { day, minutes } = sofiaNow();
      const rangeFor = d => (d >= 1 && d <= 5 ? this.hours.week : d === 6 ? this.hours.sat : null);
      const today = rangeFor(day);
      if (today && minutes >= today.from && minutes < today.to - 15) return { open: true };
      for (let i = 0; i < 7; i++) {
        const d = (day + i) % 7;
        const r = rangeFor(d);
        if (!r || (i === 0 && minutes >= r.from)) continue;
        const when = i === 0 ? 'днес' : i === 1 ? 'утре' : 'в ' + DAY_NAMES[d];
        return { open: false, next: when + ' след ' + r.label + ' ч.' };
      }
      return { open: false, next: 'в първия работен ден' };
    }

    renderAvailability() {
      const s = this.schedule();
      const minutes = this.dataset.replyMin;
      const meta = this.querySelector('[data-btqo-availability]');
      const eta = this.dialog.querySelector('[data-btqo-eta]');
      if (s.open) {
        meta.innerHTML = '<span class="btqo-dot"></span> На линия сме - обаждаме се до ~' + minutes + ' мин.';
        eta.textContent = 'Обикновено се обаждаме до ' + minutes + ' минути.';
      } else {
        meta.textContent = 'Остави заявка сега - ще ти се обадим ' + s.next;
        eta.textContent = 'В момента сме извън работно време. Ще ти се обадим ' + s.next;
      }
      this.successText = s.open
        ? 'Ще ти се обадим до около ' + minutes + ' минути.'
        : 'Ще ти се обадим ' + s.next;
    }

    /* ---------- Продукт / вариант / количество ---------- */

    syncProduct() {
      const forms = [...this.scope.querySelectorAll('form[action*="/cart/add"]')];
      let chosen = null;
      let productForm = null;
      for (const form of forms) {
        const id = form.querySelector('[name="id"]')?.value;
        const v = this.variants.find(x => String(x.id) === String(id));
        if (v) { chosen = v; productForm = form; break; }
      }
      const urlVariant = new URL(location.href).searchParams.get('variant');
      chosen ||= this.variants.find(v => String(v.id) === urlVariant);
      chosen ||= this.variants.find(v => String(v.id) === this.dataset.variant) || this.variants[0];

      // Темата държи количеството извън формата (form="product-form-...") - търсим и двете.
      const qtyInput = productForm?.elements.namedItem('quantity') || this.scope.querySelector('input[name="quantity"]');
      const quantity = Math.max(1, Math.floor(Number(qtyInput?.value) || 1));
      const url = new URL(this.dataset.url, location.origin);
      if (this.variants.length > 1) url.searchParams.set('variant', chosen.id);
      const variantName = chosen.title === 'Default Title' ? 'Стандартен' : chosen.title;

      this.current = { chosen, quantity, url, variantName };

      const summary = [chosen.title === 'Default Title' ? '' : variantName, chosen.price, quantity > 1 ? quantity + ' бр.' : '']
        .filter(Boolean).join(' · ');
      this.dialog.querySelector('[data-btqo-summary]').textContent = summary;
    }

    /* ---------- Отваряне / затваряне ---------- */

    openForm() {
      this.syncProduct();
      this.renderAvailability();
      this.prefill();
      this.showView(false);
      track('btqo_open', { product: this.dataset.title });
    }

    prefill() {
      const saved = store.get('localStorage', CUSTOMER_KEY) || {};
      const f = this.form.elements;
      if (!f['contact[name]'].value && saved.name) f['contact[name]'].value = saved.name;
      if (!f['contact[phone]'].value && saved.phone) f['contact[phone]'].value = saved.phone;
      const email = this.dialog.querySelector('[data-btqo-email]');
      if (!email.value && saved.email) email.value = saved.email;
      const vehicleInput = this.dialog.querySelector('[data-btqo-vehicle]');
      const v = this.vehicle();
      if (!vehicleInput.value && v) vehicleInput.value = v.name;
      const time = this.dialog.querySelector('[data-btqo-time]');
      if (!this.schedule().open && time.selectedIndex === 0) time.selectedIndex = 1;
    }

    showView(success) {
      this.dialog.querySelector('.btqo-entry').hidden = success;
      this.dialog.querySelector('.btqo-success').hidden = !success;
      this.dialog.setAttribute('aria-labelledby', this.id + (success ? '-thanks' : '-title'));
      if (!this.dialog.open) this.dialog.showModal();
      if (success) {
        this.dialog.querySelector('[data-btqo-success-text]').textContent = this.successText;
        this.dialog.querySelector('.btqo-success h2').focus();
      } else {
        const name = this.form.elements['contact[name]'];
        (name.value ? this.form.elements['contact[phone]'] : name).focus();
      }
    }

    resetForm() {
      this.form.querySelectorAll('[data-btqo-note], [data-btqo-vin]').forEach(el => (el.value = ''));
      this.form.querySelector('details').open = false;
      this.setBusy(false);
    }

    /* ---------- Изпращане ---------- */

    validate() {
      const f = this.form.elements;
      const name = f['contact[name]'];
      const phone = f['contact[phone]'];
      const email = this.dialog.querySelector('[data-btqo-email]');
      const vin = this.dialog.querySelector('[data-btqo-vin]');

      name.value = name.value.trim();
      name.setCustomValidity(name.value.length >= 2 ? '' : 'Моля, въведи име.');

      const normalized = normalizePhone(phone.value);
      if (normalized) phone.value = normalized;
      phone.setCustomValidity(normalized ? '' : 'Моля, въведи валиден телефон, напр. 0888 123 456.');

      email.value = email.value.trim();
      email.setCustomValidity(!email.value || /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.value) ? '' : 'Невалиден имейл.');

      vin.setCustomValidity(!vin.value || /^[A-HJ-NPR-Z0-9]{17}$/.test(vin.value) ? '' : 'VIN номерът трябва да е 17 символа (без I, O, Q).');
      if (vin.validationMessage) this.form.querySelector('details').open = true;

      for (const el of [name, phone, email, vin]) el.toggleAttribute('aria-invalid', !el.checkValidity());
      return this.form.reportValidity();
    }

    fillHidden() {
      this.syncProduct();
      const { chosen, quantity, url, variantName } = this.current;
      const v = this.vehicle();
      const email = this.dialog.querySelector('[data-btqo-email]').value;
      const note = this.dialog.querySelector('[data-btqo-note]').value.trim();
      const set = (key, value) => (this.form.querySelector('[data-field="' + key + '"]').value = value);

      this.ref = 'BT-' + Date.now().toString(36).slice(-5).toUpperCase();
      set('email', email || this.dataset.shopEmail);
      set('ref', this.ref);
      set('variant', variantName);
      set('sku', chosen.sku || '-');
      set('quantity', quantity);
      set('price', chosen.price + (quantity > 1 ? ' × ' + quantity : ''));
      set('fit', v ? v.name + ': ' + v.fit : 'Клиентът не е избрал автомобил в сайта');
      set('url', url.href);
      set('sent', new Date().toLocaleString('bg-BG', { timeZone: TZ }) + (email ? '' : ' · клиентът не е оставил имейл'));
      set('body', note || '-');

      store.set('localStorage', CUSTOMER_KEY, {
        name: this.form.elements['contact[name]'].value,
        phone: this.form.elements['contact[phone]'].value,
        email
      });
      return { value: parseFloat(String(chosen.price).replace(/[^\d,.-]/g, '').replace(',', '.')) * quantity || 0 };
    }

    async onSubmit(e) {
      if (this.form.dataset.native === 'true') return; // резервен вариант: браузърът изпраща формата сам
      e.preventDefault();
      if (this.busy) return;
      if (!this.validate()) return;

      // Капан за ботове: попълнено скрито поле → показваме успех, без да изпращаме.
      if (this.form.elements['btqo_website'].value) return this.showView(true);

      const { value } = this.fillHidden();
      const detail = { product: this.dataset.title, ref: this.ref, value };
      track('btqo_submit', detail);
      this.setBusy(true);

      let outcome;
      try {
        outcome = await this.sendAjax();
      } catch (_) {
        outcome = { status: 'fallback' };
      }

      if (outcome.status === 'ok') {
        this.setBusy(false);
        this.dialog.querySelector('[data-btqo-ref]').textContent = this.ref;
        this.showView(true);
        track('btqo_success', detail);
      } else if (outcome.status === 'error') {
        this.setBusy(false);
        this.showError(outcome.message || 'Възникна грешка. Провери данните и опитай отново.');
        track('btqo_error', Object.assign({ message: outcome.message }, detail));
      } else {
        this.submitNative(); // Shopify поиска captcha - пускаме стандартното изпращане
      }
    }

    async sendAjax() {
      const action = this.form.getAttribute('action').split('#')[0];
      const returnUrl = new URL(this.current.url);
      returnUrl.searchParams.set('btqo', this.ref);
      this.form.elements['return_to'].value = returnUrl.pathname + returnUrl.search;

      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 20000);
      const res = await fetch(action, {
        method: 'POST',
        body: new FormData(this.form),
        credentials: 'same-origin',
        signal: controller.signal
      }).finally(() => clearTimeout(timeout));

      const finalUrl = new URL(res.url, location.origin);
      if (finalUrl.pathname.includes('/challenge')) return { status: 'fallback' };
      if (finalUrl.searchParams.get('contact_posted') === 'true') return { status: 'ok' };

      const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
      const result = doc.querySelector('#' + CSS.escape(this.form.id) + ' [data-btqo-result]');
      if (!result) return { status: 'fallback' };
      if (result.dataset.posted === 'true') return { status: 'ok' };
      if (result.dataset.errors === 'true') return { status: 'error', message: result.textContent.trim() };
      return { status: 'fallback' };
    }

    submitNative() {
      const token = this.ref;
      store.set('sessionStorage', this.pendingKey, { token, at: Date.now() });
      const returnUrl = new URL(this.current.url);
      returnUrl.searchParams.set('btqo', token);
      this.form.elements['return_to'].value = returnUrl.pathname + returnUrl.search;
      this.form.dataset.native = 'true';
      if (window.Shopify?.captcha?.protect && !this.form.dataset.protected) {
        this.form.dataset.protected = 'true';
        window.Shopify.captcha.protect(this.form);
      }
      this.slowTimer = setTimeout(() => {
        this.setBusy(false);
        this.showError('Изпращането отнема повече време. Изчакай или ни се обади директно.');
      }, 25000);
      this.form.requestSubmit ? this.form.requestSubmit(this.submitButton) : this.form.submit();
    }

    // След стандартно изпращане страницата се презарежда - показваме резултата отново в прозореца.
    restoreAfterNativeSubmit() {
      const url = new URL(location.href);
      const token = url.searchParams.get('btqo');
      const pending = store.get('sessionStorage', this.pendingKey);
      const result = this.form.querySelector('[data-btqo-result]');
      if (!pending || Date.now() - pending.at > 3600000) return;

      if (token === pending.token && result.dataset.errors !== 'true') {
        store.remove('sessionStorage', this.pendingKey);
        this.renderAvailability();
        this.dialog.querySelector('[data-btqo-ref]').textContent = token;
        this.showView(true);
        track('btqo_success', { product: this.dataset.title, ref: token });
        url.searchParams.delete('btqo');
        url.searchParams.delete('contact_posted');
        history.replaceState(history.state, '', url.pathname + url.search);
      } else if (result.dataset.errors === 'true') {
        this.syncProduct();
        this.prefill();
        this.showView(false);
        this.showError(result.textContent.trim() || 'Възникна грешка. Моля, опитай отново.');
      }
    }

    setBusy(busy) {
      this.busy = busy;
      clearTimeout(this.slowTimer);
      if (!this.submitButton) return;
      this.submitButton.disabled = busy;
      this.submitButton.classList.toggle('is-loading', busy);
      this.submitButton.querySelector('.btqo-submit__label').textContent = busy ? 'Изпращане...' : this.dataset.submitLabel || 'Изпрати заявката';
      if (!busy && this.form) delete this.form.dataset.native;
    }

    showError(message) {
      this.errorBox.textContent = message;
      this.errorBox.hidden = false;
    }
  });
})();
